import type { RegistroResumoModel } from "../../../services/comparativoUnidades"

export type { RegistroResumoModel }

export type ComparativoUnidadesModel = {
    registros: RegistroResumoModel[]
    pesquisado: boolean
}

export const ComparativoUnidadesInicial: ComparativoUnidadesModel = {
    registros: [],
    pesquisado: false,
}
